import { useCallback } from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function useRootReducer(reducerMap) {
  if (!reducerMap) {
    throw new Error("useRootReducer: please pass useReducers argv");
  }

  var rootStateKeys = Object.keys(reducerMap);
  var rootState = rootStateKeys.reduce(function (lastState, key) {
    return _objectSpread2({}, lastState, _defineProperty({}, key, reducerMap[key][0]));
  }, {});
  var useRootReducerDispatch = useCallback(function (action) {
    rootStateKeys.forEach(function (key) {
      var fn = reducerMap[key][1];
      fn(action);
    });
  }, rootStateKeys);
  return [rootState, useRootReducerDispatch];
}

export default useRootReducer;
